import Image from "next/image";
import { Text } from "ui-components";

import { OrganizationSharedFileEntity } from "@/hooks/api/generated";
import { RESOURCE_CENTER_PLACEHOLDER_IMAGE } from "@/src/constants/images";
import { hasRecentUpdate } from "@/src/utils/resourceUtils";

interface ICategoryInterface {
  category: OrganizationSharedFileEntity;
  onSelectCategory?: (category: OrganizationSharedFileEntity) => void;
}
const asset_url =
  "https://res.cloudinary.com/dv6hrcluu/image/upload/f_auto/q_auto/resource-center";

export function ResourceCategoryItem({
  category,
  onSelectCategory,
}: ICategoryInterface): JSX.Element {
  const handleClick = (): void => {
    if (onSelectCategory) {
      onSelectCategory(category);
    }
  };
  return (
    <div
      onClick={handleClick}
      onKeyDown={handleClick}
      role="button"
      tabIndex={category.id}
      className="w-full pb-4 rounded-lg outline outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-start items-start gap-4 overflow-hidden"
    >
      <div className="inline-flex justify-center items-center gap-2.5 overflow-hidden">
        <Image
          src={
            category.asset
              ? category.asset.name
              : RESOURCE_CENTER_PLACEHOLDER_IMAGE
          }
          alt="illustration"
          width={640}
          height={128}
          unoptimized
        />
      </div>
      <div className="self-stretch px-4 flex flex-col justify-start items-start gap-2">
        <div className="self-stretch inline-flex justify-between items-center">
          <Text variant="large" className="text-lg">
            {category.file_name}
          </Text>
          {hasRecentUpdate(category) && (
            <div className="w-6 h-6 relative">
              <Image
                className="w-6 h-6 left-0 top-0 absolute"
                src={`${asset_url}/dotzakytv.gif`}
                height={24}
                width={24}
                alt={`Resource Center Category: ${category.file_name}`}
              />
            </div>
          )}
        </div>
        <div className="self-stretch justify-start text-neutral-600 text-sm font-medium">
          {category.files.length} documents
        </div>
      </div>
    </div>
  );
}
